/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for creating a tutorial.
 * @export
 * @interface TutorialCreate
 */
export interface TutorialCreate {
    /**
     * 
     * @type {string}
     * @memberof TutorialCreate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TutorialCreate
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TutorialCreate
     */
    is_public?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TutorialCreate
     */
    organization_ids?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof TutorialCreate
     */
    complexity?: number;
    /**
     * 
     * @type {string}
     * @memberof TutorialCreate
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TutorialCreate
     */
    field?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TutorialCreate
     */
    tag_ids?: Array<string> | null;
}

/**
 * Check if a given object implements the TutorialCreate interface.
 */
export function instanceOfTutorialCreate(value: object): value is TutorialCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function TutorialCreateFromJSON(json: any): TutorialCreate {
    return TutorialCreateFromJSONTyped(json, false);
}

export function TutorialCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TutorialCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'is_public': json['is_public'] == null ? undefined : json['is_public'],
        'organization_ids': json['organization_ids'] == null ? undefined : json['organization_ids'],
        'complexity': json['complexity'] == null ? undefined : json['complexity'],
        'language': json['language'] == null ? undefined : json['language'],
        'field': json['field'] == null ? undefined : json['field'],
        'tag_ids': json['tag_ids'] == null ? undefined : json['tag_ids'],
    };
}

export function TutorialCreateToJSON(json: any): TutorialCreate {
    return TutorialCreateToJSONTyped(json, false);
}

export function TutorialCreateToJSONTyped(value?: TutorialCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'is_public': value['is_public'],
        'organization_ids': value['organization_ids'],
        'complexity': value['complexity'],
        'language': value['language'],
        'field': value['field'],
        'tag_ids': value['tag_ids'],
    };
}

